import React, {useLayoutEffect, useRef, useState} from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import {CardActionArea, Chip, Tooltip} from "@mui/material";
import {useNavigate} from "react-router-dom";

import {DOCTORS_ROUTE} from "../utils/consts";
import {Box} from "@mui/system";
import RequestAppointmentCounter from "./RequestAppointmentCounter";
import {getImageUrl} from "../helpers/getImageUrl";

const DoctorItem = ({doctor}) => {
    const navigate = useNavigate();
    const chipsRef = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);

    useLayoutEffect(() => {
        const el = chipsRef.current;
        if (el) setIsOverflowing(el.scrollHeight > el.clientHeight);
    }, [doctor]);

    return (
        <Card
            sx={{
                width: 345,
                height: 455,
                m: 1,
                ml: 0,
                border: 1,
                borderColor: "grey.300",
                borderRadius: 1,
            }}
            elevation={0}
        >
            <CardActionArea
                sx={{height: 455, display: 'flex', flexDirection: 'column', alignItems: 'stretch'}}
                onClick={() => navigate(DOCTORS_ROUTE + "/" + doctor.id)}
            >
                <CardMedia
                    component="img"
                    height="280"
                    image={getImageUrl(doctor.image)}
                    alt=""
                />
                <CardContent sx={{display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden'}}>
                    <Typography gutterBottom variant="h5" component="div">
                        {doctor.name}
                    </Typography>

                    <Tooltip
                        title={
                            <>
                                {doctor.categories?.length > 0 && <div><b>Категории, в которых отображается врач:</b> {doctor.categories.map(c => c.name).join(', ')}</div>}
                                {doctor.branches?.length > 0 && <div><b>Филиалы, в которых отображается врач:</b> {doctor.branches.map(b => b.name).join(', ')}</div>}
                                {doctor.specializations?.length > 0 && <div><b>Специализации врача:</b> {doctor.specializations.map(s => s.name).join(', ')}</div>}
                            </>
                        }
                        arrow
                        placement="top"
                    >
                        <Box
                            ref={chipsRef}
                            sx={{
                                position: 'relative',
                                maxHeight: '72px',
                                overflow: 'hidden',
                                mb: 0.5,
                                cursor: 'pointer',
                            }}
                        >
                            {isOverflowing && (
                                <Box sx={{
                                    position: 'absolute', bottom: 0, left: 0, right: 0, height: '28px',
                                    background: 'linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1))',
                                    pointerEvents: 'none',
                                }} />
                            )}
                            {doctor.categories?.map((category) => (
                                <Chip
                                    size="small"
                                    key={category.id}
                                    label={category.name}
                                    sx={{
                                        ml: 0.5,
                                        mb: 0.5,
                                        bgcolor: '#9C27B0',
                                        color: 'white',
                                        fontWeight: 'bold'
                                    }}
                                />
                            ))}
                            {doctor.branches?.map((branch) => (
                                <Chip
                                    size="small"
                                    color="info"
                                    key={branch.name}
                                    label={branch.name}
                                    sx={{ml: 0.5, mb: 0.5}}
                                />
                            ))}
                            {doctor.specializations?.map((specialization) => (
                                <Chip
                                    size="small"
                                    color="success"
                                    key={specialization.name}
                                    label={specialization.name}
                                    sx={{ml: 0.5, mb: 0.5}}
                                />
                            ))}
                        </Box>
                    </Tooltip>

                    <Box sx={{mt: 'auto', display: 'flex', alignItems: 'center', gap: 1}}>
                        <Typography variant="body2" color="templateText.secondary">
                            Добавил: {doctor.user?.internalName || doctor.user?.name || doctor.authorInternalNameSnapshot || doctor.authorNameSnapshot || '—'}
                        </Typography>

                        <RequestAppointmentCounter count={doctor?.requestAppointmentCount} />
                    </Box>
                </CardContent>
            </CardActionArea>
        </Card>
    );
};

export default DoctorItem;
